<template>
    <div class="add-edit-form">
        <el-dialog :title="title == 'sub' ? '添加子菜单' : title == 'new' ? '添加菜单' : '编辑菜单'" :visible.sync="dialogVisible"
            :destroy-on-close="true" append-to-body width="70%">
            <div style="height: 60vh; overflow: auto;">
                <el-form :model="form" ref="form" :rules="rules" label-width="120px" size="medium">
                    <el-form-item label="菜单名称" prop="T_name">
                        <el-input v-model.trim="form.T_name"></el-input>
                    </el-form-item>
                    <el-form-item label="权限" prop="T_permission">
                        <el-input v-model.trim="form.T_permission" placeholder="只能包含字母、数字、冒号"></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-radio-group v-model.trim="form.T_type" @change="form.T_icon = ''">
                            <el-radio label="M">菜单</el-radio>
                            <el-radio label="B">按钮</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="图标" prop="T_icon" v-if="form.T_type == 'M'">
                        <el-select v-model.trim="form.T_icon" placeholder="请选择">
                            <el-option v-for="(item, index) in iconfontData" :key="index"
                                :value="`icon-${item.font_class}`">
                                <span style="float: right;" :class="`iconfont icon-${item.font_class}`"></span>
                                <span :title="item.font_class"
                                    style="float: left; color: #8492a6; font-size: 13px; max-width: 100px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{
                                        item.font_class }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序" prop="T_sort">
                        <el-input v-model.trim="form.T_sort"></el-input>
                    </el-form-item>

                    <el-form-item label="进入公司后展示">
                        <el-radio-group v-model="form.T_pid">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="API权限" prop="apis">
                        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addtable()">添加权限</el-button>
                        <el-table :data="form.apis" size="mini" style="width: 100%;margin-top: 10px;" border>
                            <el-table-column label="标题" width="180" prop="T_name"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="T_method" label="请求类型" width="80"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="T_uri" label="请求路径" show-overflow-tooltip></el-table-column>
                            <el-table-column label="操作" min-width="150">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                        @click="editTable(scope.row, scope.$index)">编辑</el-button>
                                    <el-button type="danger" size="mini"
                                        @click="form.apis.splice(scope.$index, 1)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-form>
            </div>
            <div style="text-align: center;padding-top: 20px;border-top: 1px solid #e4e7ed;">
                <el-button type="primary" size="medium" @click="submitForm">提 交</el-button>
                <el-button type="danger" size="medium" @click="dialogVisible = false">取 消</el-button>
            </div>
            <!-- 子选择 -->
            <el-dialog :title="subtitle" :visible.sync="innerVisible" :destroy-on-close="true" append-to-body>
                <el-form :model="subForm" ref="subFormRef" :rules="subRules" label-width="120px" size="medium">
                    <el-form-item label="标题" prop="T_name">
                        <el-input v-model.trim="subForm.T_name"></el-input>
                    </el-form-item>
                    <el-form-item label="请求类型" prop="T_method">
                        <el-select v-model.trim="subForm.T_method" placeholder="请选择">
                            <el-option label="POST" value="POST"></el-option>
                            <el-option label="GET" value="GET"></el-option>
                            <el-option label="PUT" value="PUT"></el-option>
                            <el-option label="DELETE" value="DELETE"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="请求路径" prop="T_uri">
                        <el-input v-model.trim="subForm.T_uri"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitSubForm()">提交</el-button>
                        <el-button type="danger" @click="innerVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>

        </el-dialog>
    </div>
</template>

<script>
import iconfontData from '@/assets/iconfont/iconfont.json';
import { _MenuGet, _MenuAdd, _MenuEdit } from '@/api/_menu/index.js';
export default {
    name: "AddEditForm",
    data() {
        return {
            title: '',
            iconfontData: iconfontData.glyphs,
            dialogVisible: false,
            form: {
                Id: '',//编辑时需要传Id
                T_mid: '',//父菜单ID
                T_name: '',//菜单名称
                T_permission: '',//权限
                T_icon: '',//图标
                T_type: 'M',//类型 M菜单 B按钮
                T_pid: 1,//1 进入公司后才能访问的菜单 0 公共菜单 
                T_sort: '',//排序
                apis: []
            },
            rules: {
                T_name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
                T_permission: [
                    { required: true, message: '请输入权限', trigger: 'change', },
                    { pattern: /^[a-zA-Z0-9:]+$/, message: '只能包含字母、数字、冒号', trigger: 'blur' }
                ],
                T_icon: [{ required: true, message: '请选择图标', trigger: 'change' }],
                T_sort: [
                    { required: true, message: '请输入排序', trigger: 'change' },
                    { pattern: /^-?\d+(\.\d+)?$/, message: '排序只能输入数字（支持整数、小数和负数）', trigger: 'blur' }
                ],
                apis: [{ required: true, message: '请添加API权限', trigger: ['change', 'blur'] }],
            },
            // 子对话框
            innerVisible: false,
            subtitle: '添加API权限',
            rowIndex: null,
            subForm: {
                T_name: '',//标题
                T_method: '',//请求类型
                T_uri: '',//请求路径
            },
            subRules: {
                T_name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                T_method: [{ required: true, message: '请选择请求类型', trigger: 'change' }],
                T_uri: [{ required: true, message: '请输入请求路径', trigger: 'blur' }],
            }
        }
    },
    mounted() {

    },
    methods: {

        async showDialogVisible(title, row) {
            this.title = title;
            this.resetFields();
            if (title == 'edit') {
                const { data: reslut } = await _MenuGet({ Id: row.Id });
                if (reslut.Code == 200) {
                    this.form = { ...reslut.Data.Data.menu, apis: reslut.Data.Data.apis || [] };
                }
            } else {

                this.form = {
                    T_mid: this.title == 'sub' ? row.Id : 0,//父菜单ID
                    T_name: '',//菜单名称
                    T_permission: '',//权限
                    T_icon: '',//图标
                    T_type: 'M',//类型 M菜单 B按钮
                    T_pid: 1,//1 进入公司后才能访问的菜单 0 公共菜单 
                    T_sort: '',//排序
                    apis: []
                }
            }
            this.dialogVisible = true;
        },
        // 提交表单
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let apiMethod = this.title === 'edit' ? _MenuEdit : _MenuAdd;
                    let obj = { ...this.form };
                    obj.T_sort = Number(obj.T_sort);
                    obj.apis = JSON.stringify(obj.apis);
                    apiMethod(obj).then(({ data: res }) => {
                        if (res.Code == 200) {
                            this.$message.success('操作成功');
                            this.dialogVisible = false;
                            this.$emit('refresh');
                        }
                    });
                }
            });
        },

        /*子表单 *******************************************************/

        // 添加API权限
        addtable() {
            this.innerVisible = true;
            this.rowIndex = null;
            this.subtitle = '添加API权限';
            this.subForm = {
                T_name: '',//标题
                T_method: '',//请求类型
                T_uri: '',//请求路径
            };
            if (this.$refs.subFormRef) {
                this.$refs.subFormRef.resetFields();
            }
        },
        editTable(row, index) {
            this.rowIndex = index;
            this.subtitle = '编辑API权限';
            this.innerVisible = true;
            let { T_name, T_method, T_uri } = row;
            this.subForm = { T_name, T_method, T_uri };
            if (this.$refs.subFormRef) {
                this.$refs.subFormRef.resetFields();
            }
        },
        // 提交子表单
        submitSubForm() {
            this.$refs.subFormRef.validate((valid) => {
                if (valid) {
                    if (this.subtitle == '编辑API权限') {//编辑API权限
                        this.$set(this.form.apis, this.rowIndex, this.subForm);
                    } else {//添加API权限
                        this.form.apis.push(this.subForm);
                    }
                    this.innerVisible = false;
                }
            });
        },
        /*公共方法 重置表单 *******************************************************/
        // 重置表单
        resetFields() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
    }
}
</script>
<style lang="scss">
/* @import url(); 引入css类 */
</style>